import { useEffect } from "react"

export const useKeyPress = (key: KeyboardEvent["key"], onPress: () => void, event?: "keydown" | "keyup") => {
    useEffect(() => {
        if (typeof window === "undefined") {
            return
        }

        const eventHandler = (e: KeyboardEvent) => {
            if (e.key === key) {
                onPress()
            }
        }

        window.addEventListener(event || "keydown", eventHandler)
        return () => {
            window.removeEventListener(event || "keydown", eventHandler)
        }
    }, [key, onPress, event])
}
